import apiClient from '@/service';
import type { IMenu } from '@/types';
import { defineStore } from 'pinia';
import { useMyPageStore } from './myPageStore';
interface Tab {
  fullPath: string;
  title: string;
  component: any; // 추가
  name: string;
}
export const useAppStore = defineStore('appStore', {
  state: () => ({
    tabs: [] as Tab[],
    current: 'asd',
    isMobile: false,
    isOpenNav: false,
    userMenuList: [] as IMenu[],
    isLoading: false,
    loadingCount: 0,
    viteMode: import.meta.env.VITE_MODE,
  }),
  actions: {
    updateIsMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    getUserMenuList() {
      return apiClient
        .get<IMenu[]>('/menu')
        .then(({ data: { data } }) => {
          this.userMenuList = data;
        })
        .catch(errorHandler);
    },
    startLoading() {
      this.loadingCount++;
      if (this.loadingCount === 1) {
        this.isLoading = true;
      }
    },
    stopLoading() {
      this.loadingCount = Math.max(0, this.loadingCount - 1);
      if (this.loadingCount === 0) {
        this.isLoading = false;
      }
    },
    resetTabs() {
      this.tabs = [];
      this.current = '';
    },
    getMenuList(code?: string) {
      const userCode = code ?? useMyPageStore().myInfo.code;
      if (!userCode) return;
      return apiClient
        .get<IMenu[]>(`/menu/user/${userCode}/authority?userMenuAuthorityYn=Y`)
        .then(({ data: { data } }) => {
          this.userMenuList = data;
        })
        .catch(errorHandler);
    },
  },
});
